import {getDefaultImageSource,postDefaultNavArticleList,getDefaultArticleInfo,postProductInfo} from '@/api'
// getDefaultArticleInfo,postDefaultSearchArticle,postDefaultSearchProduct,postDefaultNavArticleList

const actions = {
	// 图片素材
	async getPicture({commit}){
		let res = await getDefaultImageSource()
        if(!res.code){
		commit('SAVE_PICTURE',res.data)
        }else{
            alert(res.message)
        }
	},
	// 导航文章列表
	async getNavArticleData({commit},{id,currentPage,pageSize}){
		let res = await postDefaultNavArticleList({
			nav_id:id,
			page:currentPage,
			page_size:pageSize
		})
        if(!res.code){
		commit('SAVE_NAV_ARTICLE_DATA',res.data)
        }else{
            alert(res.message)
        }
	},
	// 文章内容详情
	async getArticleInfo({commit},id){
		let res = await getDefaultArticleInfo(id)
        if(!res.code){
		commit('SAVE_ARTICLE_INFO',res.data)
        }else{
            alert(res.message)
        }
	},
	// 产品内容详情
	async getProductInfo({commit},{id,scene,keyword,category_id}){
		let res = await postProductInfo({
			id,
			scene,
			keyword,
			category_id,
		})
        if(!res.code){
		commit('SAVE_PRODUCT_INFO',res.data)
        }else{
            alert(res.message)
        }
	},


}

const mutations = {
	SAVE_PICTURE(state,data){
		state.pictureData = data
	},
	SAVE_NAV_ARTICLE_DATA(state,data){
		state.navArticleInfo = data
	},
	SAVE_ARTICLE_INFO(state,data){
		state.articleDetialInfo = data
	},
	SAVE_PRODUCT_INFO(state,data){
		state.productDetialInfo = data
	},
	clear(state) {
		state.articleDetialInfo = '',
		state.productDetialInfo = ''
	},

}

const state = {
	pictureData:{
		about:{
			top_banner:[]
		},
		human:{
			top_banner:[]
		},
		introduction:{
			top_banner:[]
		},
		kindness:{
			top_banner:[]
		},
		news:{
			top_banner:[]
		},
		political:{
			top_banner:[]
		},
		product:{
			top_banner:[]
		},
		search:{
			top_banner:[]
		},
		technology:{
			top_banner:[]
		},

	},
	navArticleInfo:{},
	articleDetialInfo:{},
	productDetialInfo:{}
}

const getters = {
	
}

export default {
	actions,
	mutations,
	state,
	getters
}